
import { DashboardType, WidgetDefinition } from "@/components/admin/dashboard/widget-types";

export function useWidgetUtils(definitions: WidgetDefinition[]) {
  // Get widgets by dashboard type
  const getWidgetsByDashboardType = (type: DashboardType) => {
    return definitions.filter(
      widget => widget.isActive && (widget.dashboardType === type || widget.dashboardType === 'both')
    );
  };

  return {
    getWidgetsByDashboardType
  };
}
